import {NOMEFERMATA_END} from './nomeFermataEndTypes'

export const changeNomeFermataEnd = nomeFermataEnd => {
    return {
        type: NOMEFERMATA_END,
        load: nomeFermataEnd
    }
}

export const selectNewNomeFermataEnd = (nomeFermataEnd) => {

    return (dispatch) => {
        dispatch(changeNomeFermataEnd(nomeFermataEnd))
    }

}